import React, { useState } from 'react';
import PropTypes from 'prop-types';
import head from 'lodash.head';
import NavigationBar from '../../../navigation/NavigationBar';
import { TextCell } from '../../../../components/cell/shared/Cells';
import {
    getActivities,
    getActivitiesIdsBySkillAndGrade,
    getAvailableGradesForSkill,
} from '../../../../utils/shared/instructionUtils';
import { SUPPORTED_GRADES, getGradeTitle } from '../../../../constants/shared/GradesConstants';
import ActivitiesSection from '../../../activities/ActivitiesSection';
import ListTable from '../../../../components/listTable/ListTable';
import './AllActivities.scss';

const AllActivities = ({
    LinkWrapper,
    message,
    skills,
    activitiesData,
    groupsToActivitiesMapper,
    selectSkill,
    downloadActivity,
    isGuidedTourOn,
}) => {
    const [skillGrade, setValues] = useState({
        selectedSkill: head(skills),
        selectedGrade: head(SUPPORTED_GRADES),
    });

    const gradeTabs = skill =>
        getAvailableGradesForSkill(skill, groupsToActivitiesMapper).map(grade => ({
            id: grade,
            title: getGradeTitle(grade),
            liTagClassName: 'pointer',
        }));

    const { selectedSkill, selectedGrade } = skillGrade;

    const handleRowClick = id => {
        const newSelectedGrade = head(gradeTabs(id)).id;
        setValues({
            selectedSkill: id,
            selectedGrade: newSelectedGrade,
        });
        selectSkill(id, newSelectedGrade);
    };

    const handleGradeClick = gradeId => {
        setValues({ ...skillGrade, selectedGrade: gradeId });
        selectSkill(selectedSkill, gradeId);
    };

    const handleDownloadActivity = ({ id }) => {
        downloadActivity(id, selectedSkill, selectedGrade);
    };

    return (
        <div className="instruction-container">
            <div className="skills-table">
                <ListTable
                    isSortable={false}
                    tableTitle="Skills/Resources"
                    tableData={skills}
                    selectedItemId={selectedSkill}
                    onRowClick={handleRowClick}
                />
            </div>
            <div className="instruction-content">
                <div className={`all-activities-header ${isGuidedTourOn && 'in-tour'}`}>
                    <TextCell content={message} classNames="message" isDataCell={false} />
                    <NavigationBar
                        ulTagClassName="nav nav-horizontal"
                        tabs={gradeTabs(selectedSkill)}
                        selectedTabId={selectedGrade}
                        onNavigationTabClick={handleGradeClick}
                        LinkWrapper={LinkWrapper}
                    />
                    <TextCell content="Activities" classNames="title" isDataCell={false} />
                    <TextCell classNames="delimiter" isDataCell={false} />
                </div>
                <ActivitiesSection
                    activities={getActivities(
                        getActivitiesIdsBySkillAndGrade(
                            selectedSkill,
                            selectedGrade,
                            groupsToActivitiesMapper,
                        ),
                        activitiesData,
                    )}
                    classNames="scrollable"
                    onClickHandler={handleDownloadActivity}
                />
            </div>
        </div>
    );
};

AllActivities.defaultProps = {
    LinkWrapper: () => {},
    message: null,
    skills: [],
    activitiesData: [],
    groupsToActivitiesMapper: {},
    isGuidedTourOn: false,
    selectSkill: () => {},
    downloadActivity: () => {},
};

AllActivities.propTypes = {
    LinkWrapper: PropTypes.func,
    message: PropTypes.string,
    skills: PropTypes.array,
    activitiesData: PropTypes.array,
    groupsToActivitiesMapper: PropTypes.object,
    selectSkill: PropTypes.func,
    downloadActivity: PropTypes.func,
    isGuidedTourOn: PropTypes.bool,
};

export default AllActivities;
